import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import {
  AddLearningResourcesDto,
  LearningResource,
  LearningResourceItem,
  RemoveLearningResourcesDto,
  UpdateActivityDueDateDto,
  UpdateLearningResourceDto,
} from "src/app/_models/LearningResource";
import { MessageResultDto } from "src/app/_models/MessageResultDto";
import { LearningResourceActionTypes } from "src/app/constants/StoreConstants";

export const ResetLearningResourcesState = createAction(
  LearningResourceActionTypes.ResetLearningResourcesState
);

export const ResetLearningResourcesTables = createAction(
  LearningResourceActionTypes.ResetLearningResources
);

export const ResetLearningResourcesTablesSuccess = createAction(
  LearningResourceActionTypes.ResetLearningResourcesSuccess
);

export const GetLearningResources = createAction(
  LearningResourceActionTypes.GetLearningResources,
  props<{
    courseId: number;
    learnerId: number;
    subCategoryCode: string;
    isInitialLoad: boolean;
  }>()
);

export const GetLearningResourcesSuccess = createAction(
  LearningResourceActionTypes.GetLearningResourcesSuccess,
  props<{ result: LearningResource }>()
);

export const GetLearningResourcesError = createAction(
  LearningResourceActionTypes.GetLearningResourcesError,
  props<{ error: HttpErrorResponse }>()
);

export const UpdateLearningResources = createAction(
  LearningResourceActionTypes.UpdateLearningResources,
  props<{ params: UpdateLearningResourceDto }>()
);

export const UpdateLearningResourcesError = createAction(
  LearningResourceActionTypes.UpdateLearningResourcesError,
  props<{ error: HttpErrorResponse }>()
);

export const UpdateActivityDueDate = createAction(
  LearningResourceActionTypes.UpdateActivityDueDate,
  props<{ params: UpdateActivityDueDateDto }>()
);

export const UpdateActivityDueDateSuccess = createAction(
  LearningResourceActionTypes.UpdateActivityDueDateSuccess,
  props<{ result: MessageResultDto }>()
);

export const UpdateActivityDueDateError = createAction(
  LearningResourceActionTypes.UpdateActivityDueDateError,
  props<{ error: HttpErrorResponse }>()
);

export const AddLearningResources = createAction(
  LearningResourceActionTypes.AddLearningResources,
  props<{ addDto: AddLearningResourcesDto }>()
);

export const AddLearningResourcesSuccess = createAction(
  LearningResourceActionTypes.AddLearningResourcesSuccess,
  props<{ result: MessageResultDto }>()
);

export const AddLearningResourcesError = createAction(
  LearningResourceActionTypes.AddLearningResourcesError,
  props<{ error: HttpErrorResponse }>()
);

export const RemoveLearningResources = createAction(
  LearningResourceActionTypes.RemoveLearningResources,
  props<{ removeDto: RemoveLearningResourcesDto }>()
);

export const RemoveLearningResourcesSuccess = createAction(
  LearningResourceActionTypes.RemoveLearningResourcesSuccess,
  props<{ result: MessageResultDto }>()
);

export const RemoveLearningResourcesError = createAction(
  LearningResourceActionTypes.RemoveLearningResourcesError,
  props<{ error: HttpErrorResponse }>()
);

export const GetModuleType = createAction(
  LearningResourceActionTypes.GetModuleType,
  props<{ courseId: number }>()
);

export const GetModuleTypeSuccess = createAction(
  LearningResourceActionTypes.GetModuleTypeSuccess,
  props<{ moduleTypes: string[] }>()
);

export const GetLearningResourceItems = createAction(
  LearningResourceActionTypes.GetLearningResourceItems,
  props<{ learnerId: number; courseId: number; objectIds: string[] }>()
);

export const GetLearningResourceItemsSuccess = createAction(
  LearningResourceActionTypes.GetLearningResourceItemsSuccess,
  props<{ learningResourceItems: LearningResourceItem[] }>()
);

export const GetLearningResourceItemsError = createAction(
  LearningResourceActionTypes.GetLearningResourceItemsError,
  props<{ error: HttpErrorResponse }>()
);
